import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import { COLORS } from 'shared/constants/COLORS';
const { ERROR_ICON, PLAIN_ICON } = COLORS;

export function WrongIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} width="31" height="31" viewBox="0 0 31 31" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#iwi6j0ra5a)">
        <path
          d="M26.16 26.111c5.86-5.86 5.86-15.36 0-21.22-5.86-5.86-15.361-5.86-21.221 0-5.86 5.86-5.86 15.36 0 21.22 5.86 5.86 15.36 5.86 21.22 0z"
          fill={props.htmlColor || ERROR_ICON}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.118 22.19 9.51 11.583a1.503 1.503 0 0 1 0-2.121 1.503 1.503 0 0 1 2.122 0l10.607 10.607a1.503 1.503 0 0 1 0 2.121 1.503 1.503 0 0 1-2.121 0z"
          fill={props.htmlColor || PLAIN_ICON}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.51 20.069 20.118 9.462a1.503 1.503 0 0 1 2.12 0 1.503 1.503 0 0 1 .001 2.12L11.632 22.19a1.503 1.503 0 0 1-2.121 0 1.503 1.503 0 0 1 0-2.121z"
          fill={props.htmlColor || PLAIN_ICON}
        />
      </g>
      <defs>
        <clipPath id="iwi6j0ra5a">
          <path fill={props.htmlColor || PLAIN_ICON} transform="translate(.548 .5)" d="M0 0h30v30H0z" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}

export default WrongIcon;
